// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3jXSS","errors":"Errors_errors__xWqDx"};